import React, { useState } from "react";
import ReactDataGrid from "react-data-grid";
import PropTypes from "prop-types";
import { ProductData } from "../types/index.js";
import { DesktopDashboard } from "./styles.js";
import { columns } from "../gridConfiguration.js";

const ProductsTable = ({ data }) => {
  const [rows, setRows] = useState(data);

  const sortRows = (rows, sortColumn, sortDirection) => (rows) => {
    const comparer = (a, b) => {
      if (sortDirection === "ASC") {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    };

    return sortDirection === "NONE" ? rows : [...rows].sort(comparer);
  };

  return (
    <DesktopDashboard>
      <ReactDataGrid
        columns={columns}
        rowGetter={(i) => rows[i]}
        rowsCount={rows.length}
        headerRowHeight={60}
        rowHeight={60}
        minHeight={500}
        onGridSort={(sortColumn, sortDirection) => {
          setRows(sortRows(data, sortColumn, sortDirection));
        }}
      />
    </DesktopDashboard>
  );
};

ProductsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(ProductData)).isRequired,
};

export default ProductsTable;
